export const sortItems = [
  { id: '1', label: 'Model name', field: 'name' },
  { id: '2', label: 'Max. words', field: 'words_text' },
  { id: '3', label: 'Cost per 100 words', field: 'coinsToSort' },
  { id: '4', label: 'Last 30-Day Runs', field: 'model_runs' },
  { id: '5', label: 'Launch date', field: 'model_date' },
];
